export function isActive(element: string, array: string[]) {
  return array.find((el: string) => el === element);
}

export function copy(obj: any) {
  let result;
  if (obj instanceof Array) {
    result = [...obj];
  } else if (obj instanceof Object) {
    result = { ...obj };
  } else {
    return obj;
  }
  for (const prop of Reflect.ownKeys(result)) {
    result[prop] = copy(result[prop]);
  }
  return result;
}

export function removeNullOrEmpty<T>(obj: any): T {
  const result = Object.fromEntries(
    Object.entries(obj)
      .filter(([_, v]) => v != null && v !== "")
      .map(([k, v]) => [k, v === Object(v) ? removeNullOrEmpty(v) : v]),
  );

  return result as unknown as T;
}

export function deepAssign<T>(
  target: Record<string, any>,
  ...sources: Record<string, any>[]
) {
  sources.forEach((source) => {
    Object.keys(source).forEach((key) => {
      if (
        typeof source[key] === "object" &&
        source[key] !== null &&
        !(source[key] instanceof Date)
      ) {
        if (
          !target[key] ||
          typeof target[key] !== "object" ||
          target[key] instanceof Date
        ) {
          target[key] = Array.isArray(source[key]) ? [] : {};
        }
        deepAssign(target[key], source[key]);
      } else if (source[key] !== undefined && source[key] !== null) {
        target[key] = source[key];
      }
    });
  });
  return target as T;
}

export function sliceIntoChunks<T>(arr: T[], chunkSize: number): T[][] {
  const res = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    res.push(chunk);
  }
  return res;
}
